<nz-modal [(nzVisible)]="isVisibleExpenseModal" nzClassName="siteModal site-edit-modal invoice-modal"
    [nzTitle]="titleTemplate" (nzOnCancel)="handleCancel(null)" [nzFooter]="footerTpl" nzCentered
    [nzMaskClosable]="false">

    <ng-template #titleTemplate let-control>
        Expense
        {{getExpenseDetail && this.getExpenseDetail?.referenceNo ? this.getExpenseDetail?.referenceNo : ''}}
        <span *ngIf="getExpenseDetail && getExpenseDetail.isMarkedAsUnderReview" class="Investment-modal-status ml-1"
            [ngStyle]="{'background-color':getExpenseDetail?.underReviewColor  ?getExpenseDetail?.underReviewColor : 'red' , 'color': '#fff'}">Under
            Review</span>
        <span nz-icon nzType="sync" nzTheme="outline" [nzSpin]="isResyncingData" (click)="resynExpenseData()"
            class="ml-1 x-lg" nz-tooltip [nzTooltipTitle]="isResyncingData ? 'Syncing...' : 'Resync Expense'"></span>
    </ng-template>

    <ng-container *nzModalContent class="h-100">
        <div style="overflow: auto; height: 75vh" cdkScrollable>
            <div class="page-padding bg-white-color">
                <div nz-row class="d-flex align-i-c ">
                    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                        <h1 class="page-title-text tab-title">Expense Details</h1>
                    </div>
                </div>
            </div>

            <div class="page-padding bg-white-color">
                <div class="detail-box customer-detail-box" nz-row>

                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="24" class="quickbooks-bg-color">

                        <div nz-row class="quickbooks-bg-color quickboos-box" style=" border-bottom: 0;">
                            <div class="box-padding">
                                <nz-skeleton *ngIf="this.isExpenseSkeleton" [nzParagraph]="{ rows: 15,width: 10}"
                                    [nzActive]="true"></nz-skeleton>
                                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="24"
                                    class="section-top-padding" *ngIf="!this.isExpenseSkeleton">
                                    <!-- <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Expense ID</label>
                                    <p class="investment-company-name pb-0">
                                        <span *ngIf="(this.getExpenseDetail?.expenseId != null && this.getExpenseDetail?.expenseId != '') else elsepart "><a  target="_blank"
                                            [href]="qboURL + '/app/expense?txnId='+this.getExpenseDetail?.expenseId">{{ this.getExpenseDetail?.expenseId}}  <img class="padding-6px" src="./assets/images/Link.svg"></a>
                                    </span></p>
                                </div> -->
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Payee</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.payee != null && this.getExpenseDetail?.payee != '') else elsepart ">
                                                {{this.getExpenseDetail?.payee}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Payment Account</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.paymentAccount != null && this.getExpenseDetail?.paymentAccount != '') else elsepart ">{{this.getExpenseDetail?.paymentAccount}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Payment Date</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.paymentDate != null && this.getExpenseDetail?.paymentDate != '') else elsepart ">{{this.getExpenseDetail?.paymentDate
                                                | date: 'MM/dd/yyyy'}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Payment Method</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.paymentMethod != null && this.getExpenseDetail?.paymentMethod != '') else elsepart ">{{this.getExpenseDetail?.paymentMethod}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Reference No.</label>
                                        <p class="investment-company-name pb-0">
                                            <span>
                                                <a target="_blank"
                                                    [href]="qboURL + '/app/expense?txnId='+this.getExpenseDetail?.expenseId">{{this.getExpenseDetail?.referenceNo
                                                    ? this.getExpenseDetail?.referenceNo : 'No Ref No. Available'}}</a>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Category</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.category != null && this.getExpenseDetail?.category != '') else elsepart ">{{this.getExpenseDetail?.category}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Description</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.description != null && this.getExpenseDetail?.description != '') else elsepart ">{{this.getExpenseDetail?.description}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Amount</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.amount != null && this.getExpenseDetail?.amount != '') else elsepart ">{{this.getExpenseDetail?.amount
                                                | currency }}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Service Fee</label>
                                        <p class="investment-company-name pb-0">
                                            <!-- *ngIf="(this.getExpenseDetail?.serviceFee != null && this.getExpenseDetail?.serviceFee != 0 && this.getExpenseDetail.isServiceFeeExistsQbo) else elsepart "-->
                                            <span>{{this.getExpenseDetail?.serviceFee | currency }}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Class</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.class != null && this.getExpenseDetail?.class != '') else elsepart ">{{this.getExpenseDetail?.class}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Memo</label>
                                        <p class="investment-company-name pb-0">
                                            <span class="multiline-text"
                                                *ngIf="(this.getExpenseDetail?.memo != null && this.getExpenseDetail?.memo != '') else elsepart ">{{this.getExpenseDetail?.memo}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Attachment</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getExpenseDetail?.qboAttachment != null && this.getExpenseDetail?.qboAttachment != '') else elsepart "><a
                                                    *ngIf="qboOriginalbillLink!=null" target="_blank"
                                                    [href]="this.qboOriginalbillLink">{{this.getExpenseDetail?.qboAttachment}}
                                                    <img class="padding-6px" src="./assets/images/Link.svg"></a></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <ng-template #elsepart let-event>
                        <span>-</span>
                    </ng-template>

                    <form nz-form [formGroup]="_fS.expenseForm" class="estimate-box">
                        <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="programError">
                                        <label class="label-text required border-bottom">Select program period</label>
                                        <nz-select nzShowSearch nzPlaceHolder="Select Program Period"
                                            [nzSize]="'default'" formControlName="programPeriod" [nzSelectOnTab]="true">
                                            <ng-container *ngFor="let option of listOfProgramPeriods">
                                                <nz-option *ngIf="!isLoadingPrograms" [nzLabel]="option.label"
                                                    [nzValue]="option.id">
                                                </nz-option>
                                            </ng-container>
                                            <nz-option *ngIf="isLoadingPrograms" nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #programError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select program
                                                period
                                            </ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="tagError">
                                        <div class="d-flex align-i-c justify-content-space-between"><label
                                                class="label-text required">
                                                Tags</label></div>
                                        <nz-select nzShowSearch nzPlaceHolder="Select Tag" [nzSize]="'default'"
                                            formControlName="tags" (nzFocus)="getTags()" [nzSelectOnTab]="true"
                                            (ngModelChange)="checkTagGroupData($event)" [nzServerSearch]="true"
                                            [nzCustomTemplate]="defaultTemplate"
                                            (nzOnSearch)="returnFilteredTags($event)">
                                            <ng-container *ngFor="let option of listOfTags">
                                                <ng-container *ngIf="!isLoadingTags">
                                                    <nz-option-group [nzLabel]="optionGrouptemplate">
                                                        <nz-option *ngFor="let tag of option.Tags" nzCustomContent
                                                            [nzValue]="tag._id" [nzLabel]="tag.Name">
                                                            <span class="tag-list ml-2">
                                                                <span [ngStyle]="{'background-color': option.Color }"
                                                                    style="width: 10px;height:30px"></span>&nbsp;{{option.Name}}{{option.Name
                                                                != 'Uncategorized' ? ':' : ''}}&nbsp;
                                                                <b *ngIf="option.Name != 'Uncategorized'">{{
                                                                    tag.Name }}</b>
                                                            </span>
                                                        </nz-option>
                                                    </nz-option-group>
                                                    <ng-template #optionGrouptemplate><span
                                                            class="d-flex align-i-c"><span
                                                                class="rountTagGroupColor rount-tag"
                                                                [ngStyle]="{'background-color':option.Color}"></span><span
                                                                class="tag-group pl-15">{{option.Name}}</span></span></ng-template>
                                                </ng-container>
                                            </ng-container>
                                            <nz-option *ngIf="isLoadingTags" nzDisabled nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #defaultTemplate let-selected>
                                            <span class="tag-list ml-2">
                                                <span [ngStyle]="{'background-color': this.selectedTagGroup?.Color }"
                                                    style="width: 10px;height:30px"></span>&nbsp;{{
                                                selectedTagGroup?.Name
                                                }}{{selectedTagGroup.Name != 'Uncategorized' ? ':' : ''}}&nbsp; <b
                                                    *ngIf="selectedTagGroup.Name != 'Uncategorized'">{{
                                                    selected?.nzLabel }}</b>
                                            </span>

                                        </ng-template>
                                        <ng-template #tagError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select
                                                tag</ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="4">
                                <nz-form-item class="margin-none h-100">
                                    <nz-form-control class="switch-box justify-content-center">
                                        <nz-switch formControlName="isNonAlc"></nz-switch>
                                        <label class="switch-label black mr-1">Non-Alc</label>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="4">
                                <div>
                                    <label class="label-text border-bottom">Balance</label>
                                    <div>
                                        <p class="balance-text">
                                            {{0 | currency}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="4">
                                <div>
                                    <label class="label-text border-bottom">Net</label>
                                    <div>
                                        <p class="net-text">
                                            -{{(this.getExpenseDetail?.amount + this.getExpenseDetail?.serviceFee) |
                                            currency}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </ng-container>

    <!--mark investment under review Modal-->
    <nz-modal [(nzVisible)]="isConfirmUnderReviewVisible" nzCentered [nzMaskClosable]="false" nzTitle="Under Review"
        (nzOnCancel)="isConfirmUnderReviewVisible = false">
        <div class="confirm-modal">
            <ng-container *nzModalContent>
                <nz-form-item>
                    <nz-form-control>
                        <label class="label-text required">Select Reason</label>
                        <!-- (ngModelChange)="getInvestorPaybevBySiteId();focusPartnerDD($event)" -->
                        <nz-select nzShowSearch nzPlaceHolder="Select Reason" [nzSize]="'default'"
                            [nzSelectOnTab]="true" [(ngModel)]="reviewReason"
                            (ngModelChange)="underReviewReasonChange()">
                            <ng-container *ngFor="let option of listOfUnderReviewReasons">
                                <nz-option [nzLabel]="option.reason" [nzValue]="option.id">
                                </nz-option>
                            </ng-container>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </ng-container>
            <div *nzModalFooter class="center border-none ant-drawer-footer">
                <button nz-button nzType="default" (click)="isConfirmUnderReviewVisible = false"
                    class="dlt-btn width-100 ">Cancel</button>
                <button nz-button nzType="primary" (click)="updateTransactionWithUnderRviewReason(true)"
                    [nzLoading]="isMarkingReviewed" class=" medium-btn delete-btn width-100">Mark As Under
                    Review</button>
            </div>
        </div>
    </nz-modal>


    <ng-template #footerTpl>
        <div class="d-flex justify-content-space-between footer-box">
            <div class="ant-drawer-footer invoice-footer justify-content-space-between">
                <div class="d-flex" style="width: 50%;">
                    <!-- updateBill('ur') -->
                    <button nz-button nzType="default" (click)="markExpenseUnderReview()"
                        *ngIf="selectedData!=null && !this.getExpenseDetail?.isMarkedAsUnderReview"
                        class="default-btn review-btn under-review"
                        [ngClass]="{'under-review' : this.getExpenseDetail?.isMarkedAsUnderReview}">Under
                        Review</button>
                    <!-- [ngStyle]="{'border-color': this.getExpenseDetail?.underReviewInfo?.color ? this.getExpenseDetail?.underReviewInfo?.color : 'red', 'color': this.getExpenseDetail?.underReviewInfo?.color || 'red'}" -->
                    <button nz-button nzType="default" *ngIf="this.getExpenseDetail?.isMarkedAsUnderReview"
                        (click)="updateTransactionWithUnderRviewReason(false)" class="under-review"
                        [nzLoading]="isMarkingReviewed">Mark as Reviewed</button>
                    <!-- [ngStyle]="{'color': this.getExpenseDetail?.underReviewInfo?.color || 'red'}" -->
                    <div class="underReviewReasonText ellipsis-text" *ngIf="this.getExpenseDetail?.underReviewReason"
                        [ngClass]="this.getExpenseDetail?.isMarkedAsUnderReview === false ? 'cl-gray' : ''">
                        {{this.getExpenseDetail?.underReviewReason}}</div>
                </div>
                <div class="d-flex">
                    <button nz-button nzType="default" (click)="handleCancel(null)"
                        class="dlt-btn width-100">Close</button>
                    <button nz-button nzType="primary" class="medium-btn width-100" [nzLoading]="isLoadingExpense"
                        (click)="updateExpense()">Save</button>
                </div>
            </div>
        </div>
    </ng-template>
</nz-modal>